import gql from 'graphql-tag';

export const mutationViewIntegrationEmail = gql`
  mutation viewIntegrationEmail (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    viewIntegrationEmail (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationViewIntegrationEmail;
